module.exports = __webpack_public_path__ + "img/lovech.be671ed4.jpg";